document.addEventListener("DOMContentLoaded", function () {
  // Form playlist
  const playlistForm = document.querySelector(".playlist_form");
  if (playlistForm) {
    playlistForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const selectedSong = document.querySelector('input[name="song"]:checked');
      if (!selectedSong) {
        alert("Seleziona una canzone prima di continuare!");
        return;
      }

      const songText = document.querySelector(
        `label[for="${selectedSong.id}"]`
      ).textContent;

      const submitBtn = e.target.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = "Invio in corso...";

      setTimeout(() => {
        showPlaylistModal(songText);
        submitBtn.disabled = false;
        submitBtn.textContent = "Invia la tua scelta";
      }, 1500);
    });
  }

  // Form prodotti/codice sconto
  const productsForm = document.querySelector(".products_form");
  if (productsForm) {
    productsForm.addEventListener("submit", function (e) {
      e.preventDefault();

      const selectedCode = document.querySelector(
        'input[name="discount_code"]:checked'
      );
      if (!selectedCode) {
        alert("Seleziona un codice sconto prima di continuare!");
        return;
      }

      const submitBtn = e.target.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = "Verifica in corso...";

      setTimeout(() => {
        const isCorrect = selectedCode.value === "XMEÈNOVI";
        showDiscountModal(isCorrect, selectedCode.value);
        submitBtn.disabled = false;
        submitBtn.textContent = "Tenta la fortuna";
      }, 1500);
    });
  }
});

// Modale per playlist - usa il modale HTML esistente
function showPlaylistModal(songTitle) {
  const modal = document.getElementById("confirmation-modal");
  if (!modal) {
    console.error("Confirmation modal not found!");
    return;
  }

  document.querySelector(".modal-song-title").textContent = songTitle;

  modal.style.display = "flex";
  modal.style.opacity = "0";

  setTimeout(() => {
    modal.style.transition = "opacity 0.3s ease-in-out";
    modal.style.opacity = "1";
  }, 10);

  setupModalClose(modal);
}

// Modale per codice sconto - usa il modale HTML dedicato
function showDiscountModal(isCorrect, selectedCode) {
  const modal = document.getElementById("discount-modal");

  if (!modal) {
    console.error("Discount modal not found!");
    return;
  }

  // Modifica il contenuto del modale dedicato
  const titleElement = document.getElementById("discount-title");
  const messageElement = document.getElementById("discount-message");
  const ctaElement = document.getElementById("discount-cta");
  const copyElement = document.getElementById("discount-copy");

  if (isCorrect) {
    titleElement.textContent = "Hai indovinato!";
    messageElement.innerHTML = `Copia il codice e usalo per un -20% su Crema Novi nel nostro shop:<br><br><strong class="discount-code">${selectedCode}</strong> `;
    ctaElement.textContent = "vai allo shop";
    ctaElement.href = "https://www.elah-dufour.it/concorsi/novi-x-factor-2025";
    ctaElement.target = "_blank";
    copyElement.style = "display: block;";

    copyElement.addEventListener("click", () => {
      navigator.clipboard.writeText(`${selectedCode}`);
    });
  } else {
    titleElement.textContent = "Ritenta!";
    messageElement.innerHTML = "";
    ctaElement.textContent = "chiudi";
    ctaElement.href = "";
    copyElement.style = "display: none;";
  }

  // Mostra il modale con fade in
  modal.style.display = "flex";
  modal.style.opacity = "0";

  setTimeout(() => {
    modal.style.transition = "opacity 0.3s ease-in-out";
    modal.style.opacity = "1";
  }, 10);

  setupModalClose(modal);
}

function setupModalClose(modal) {
  // Funzione per chiudere con fade out
  function closeModal() {
    modal.style.transition = "opacity 0.3s ease-in-out";
    modal.style.opacity = "0";
    setTimeout(() => {
      modal.style.display = "none";
    }, 300);
  }

  // Chiudi con X
  const closeBtn = modal.querySelector(".close");
  if (closeBtn) {
    closeBtn.onclick = closeModal;
  }

  // Chiudi con bottone
  const btnClose = modal.querySelector(".btn-close");
  if (btnClose) {
    btnClose.onclick = closeModal;
  }

  // Chiudi cliccando fuori
  window.onclick = function (event) {
    if (event.target == modal) {
      closeModal();
    }
  };
}
